
const FrankImage = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="w-64 h-64 bg-gradient-to-br from-[#2F80ED] to-[#1A237E] rounded-full flex items-center justify-center shadow-lg">
        <img 
          src="/lovable-uploads/9048b14a-0627-4181-9970-b70f455db5ac.png"
          alt="Frank - AI Assistant"
          className="w-56 h-56 object-cover rounded-full"
          loading="eager"
        />
      </div>
    </div>
  );
};

export default FrankImage;
